import { Get, Put } from "services/apiService";
import {
  GET_GOLDEN_STORE_REQUEST,
  GET_GOLDEN_STORE_SUCCESS,
  GET_GOLDEN_STORE_FAILURE,
  ADD_GOLDEN_STORE_REQUEST,
  ADD_GOLDEN_STORE_SUCCESS,
  ADD_GOLDEN_STORE_FAILURE,
  GET_GOLDEN_STORE_SEARCH_SUCCESS,
  RESET_SEARCH_RESULT,
  GET_GOLDEN_STORE_SEARCH_FAILURE,
  GET_GOLDEN_STORE_SEARCH_REQUEST,
  ADD_GOLDEN_STORE_RESET,
} from "../actions/action-type";
import { BASE_URL, SOMS_API_KEY } from "services/CONSTANTS";

export const resetSearchResult=()=>{
  return{
    type: RESET_SEARCH_RESULT
  }
}

export const getGoldenStoreData = (storeIds, endDate) => {
  return (dispatch) => {
    const apiUrl = `${BASE_URL}goldenstores?store-ids=${storeIds}&end-date=${endDate}&apikey=${SOMS_API_KEY}`;
    // const apiUrl = `https://somsv1.np.supplychain.morconnect.com/dev/soms/v1/goldenstores?storeIds=${storeIds}&endDate=${endDate}`;
   
    dispatch({ type: GET_GOLDEN_STORE_REQUEST });
    Get( {url:apiUrl} )
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: GET_GOLDEN_STORE_SUCCESS,
            payload: response.data.goldenStores,
          });
        } else {
          dispatch({
            type: GET_GOLDEN_STORE_FAILURE,
            payload: response.data.errorMessage,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_GOLDEN_STORE_FAILURE,
          payload: err.errorMessage,
        });
      });
  };
};

export const getGoldenStoreSearchedData = (storeIds, endDate) => {
  return (dispatch) => {
    const apiUrl = `${BASE_URL}goldenstores?store-ids=${storeIds}&end-date=${endDate}&apikey=${SOMS_API_KEY}`;
    // const apiUrl = `https://somsv1.np.supplychain.morconnect.com/dev/soms/v1/goldenstores?storeIds=${storeIds}&endDate=${endDate}`;
    
    dispatch({ type: GET_GOLDEN_STORE_SEARCH_REQUEST });
    Get( {url:apiUrl} )
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: GET_GOLDEN_STORE_SEARCH_SUCCESS,
            payload: response.data,
          });
        } else {
          dispatch({
            type: GET_GOLDEN_STORE_SEARCH_FAILURE,
            payload: response.data,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_GOLDEN_STORE_SEARCH_FAILURE,
          payload: err,
        });
      });
  };
};



export const addGoldenStoreData=(newStores,storeIds)=>{
    return (dispatch) => {
        const apiUrl = `${BASE_URL}goldenstores/@all?apikey=${SOMS_API_KEY}`;
        // const apiUrl = `https://somsv1.np.supplychain.morconnect.com/dev/soms/v1/goldenstores/911`;
        
        dispatch({ type: ADD_GOLDEN_STORE_REQUEST });
        Put( {url:apiUrl, params:newStores} )
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              dispatch({
                type: ADD_GOLDEN_STORE_SUCCESS,
                payload: response.data,
              });
            } else {
              dispatch({
                type: ADD_GOLDEN_STORE_FAILURE,
                payload: response.data,
              });
            }
          })
          .catch((err) => {
            dispatch({
              type: ADD_GOLDEN_STORE_FAILURE,
              payload: err,
            });
          });
      };
}

export const resetAddGoldenStoreResult=()=>{
  return{
    type: ADD_GOLDEN_STORE_RESET
  }
}
